<template>
  <div class="container">
    <div class="bread">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item class="bread1" :to="{ path: '/tradingProject' }"
          >| 交易项目</el-breadcrumb-item
        >
        <el-breadcrumb-item class="bread1"
          ><span style="color: red; user-select: none"
            >项目详情</span
          ></el-breadcrumb-item
        >
      </el-breadcrumb>
    </div>
    <!-- 项目图片轮播展示 -->
    <div style="position: relative; margin-bottom: 20px">
      <div style="display: flex">
        <div class="particulars">
          <div class="slideshow">
            <el-carousel
              :interval="5000"
              arrow="always"
              height="380px"
              ref="carousel">
              <el-carousel-item v-for="(item, index) in imgList" :key="index">
                <img
                  :src="item"
                  style="width: 100%; height: 380px; margin: 0 auto" />
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="lunbo-bottom">
            <div
              v-for="(item, index) in imgList"
              :key="index"
              class="lunbo-item"
              @click="qiehuanlunbo(index)">
              <img :src="item" style="width: 100%; height: 100%" />
            </div>
          </div>
        </div>
        <!-- 右侧商品详细栏 -->
        <div class="left-xiangqing">
          <div class="top-title">
            <div style="color: #f56c6c; font-weight: 700">
              {{
                detail.areaName &&
                detail.projectname &&
                detail.areaName + detail.projectname
              }}{{
                detail.isRepeat > 1 && detail.isRepeat < 11
                  ? `(${numberToChinese(detail.isRepeat)}次)`
                  : ''
              }}
            </div>
            <div class="sub-title">
              <span>项目编码：{{ detail.numbering }}</span
              ><span
                >发布时间：{{
                  timeDetail.createTime ? timeDetail.createTime : ''
                }}</span
              >
            </div>
          </div>
          <div style="display: flex">
            <div class="left-bottom" style="flex: 1">
              <div class="miaoshuBox">
                {{ cityDetail.initPriceTitle || '公告价格' }}：<span
                  class="miaoshu"
                  :title="
                    detail.price +
                    ' 元/年/' +
                    getDictValue(detail.areaUnit, 'area_unit')
                  "
                  >{{ detail.price }} 元/年/{{
                    getDictValue(detail.areaUnit, 'area_unit')
                  }}</span
                >
              </div>
              <div v-if="detail.status > 6" class="miaoshuBox">
                {{ cityDetail.bargainPriceTitle || '中标价格' }}：<span
                  class="miaoshu"
                  :title="
                    detail.dealAmount
                      ? detail.dealAmount +
                        (' 元/年/' + getDictValue(detail.areaUnit, 'area_unit'))
                      : '无人出价'
                  "
                  >{{
                    detail.dealAmount
                      ? detail.dealAmount +
                        (' 元/年/' + getDictValue(detail.areaUnit, 'area_unit'))
                      : '无人出价'
                  }}
                </span>
              </div>
              <div class="miaoshuBox">
                数量：<span
                  class="miaoshu"
                  :title="
                    detail.area +
                    ' ' +
                    getDictValue(detail.areaUnit, 'area_unit')
                  "
                  >{{
                    detail.area +
                    ' ' +
                    getDictValue(detail.areaUnit, 'area_unit')
                  }}</span
                >
              </div>
              <div class="miaoshuBox">
                坐落位置：<span class="miaoshu" :title="detail.address">{{
                  detail.address
                }}</span>
              </div>
              <div class="miaoshuBox">
                转出方名称：<span class="miaoshu" :title="detail.outname">{{
                  detail.outname
                }}</span>
              </div>
              <div v-if="detail.rollout != 2" class="miaoshuBox">
                拟转出时间：<span
                  class="miaoshu"
                  :title="detail.outstarttime + ' 至 ' + detail.outstoptime">
                  {{ detail.outstarttime }} 至 {{ detail.outstoptime }}</span
                >
              </div>
              <div
                v-if="detail.status == 6"
                style="font-size: 24px; font-weight: bold"
                class="miaoshuBox">
                当前价格：<span
                  class="miaoshu"
                  :title="
                    currentPrice +
                    ' 元/年/' +
                    getDictValue(detail.areaUnit, 'area_unit')
                  "
                  style="font-size: 24px; font-weight: bold"
                  >{{ currentPrice }} 元/年/{{
                    getDictValue(detail.areaUnit, 'area_unit')
                  }}</span
                >
              </div>

              <div
                v-if="detail.status == 6 && isApply == 1"
                style="
                  display: flex;
                  align-items: center;
                  height: 50px;
                  font-size: 24px;
                  font-weight: bold;
                ">
                出价：
                <el-input
                  class="input-number"
                  v-model="money"
                  style="width: 200px"
                  @blur="moneyBlur"></el-input>
                元/年/{{ getDictValue(detail.areaUnit, 'area_unit') }}
                <div>
                  <img
                    src="@/assets/img/yijia.png"
                    style="height: 30px; width: 30px; margin-left: 6px" />
                  <span style="color: #ed222f; margin-left: 6px"
                    >溢价率:{{ overRatio ? overRatio : '--' }}%</span
                  >
                </div>
              </div>
              <div class="miaoshuBox">
                浏览次数：<span class="miaoshu" :title="detail.watchCts + ' 次'"
                  >{{ detail.watchCts ? detail.watchCts : '0' }} 次</span
                >
              </div>
              <div v-if="!cityDetail.notShowWatchNum" class="miaoshuBox">
                报名人数：<span class="miaoshu" :title="detail.signCts + ' 人'"
                  >{{ detail.signCts ? detail.signCts : '0' }} 人</span
                >
              </div>
              <div
                v-if="
                  (detail.status == 2 || detail.status >= 7) &&
                  !cityDetail.notShowPublicity
                "
                class="miaoshuBox">
                公示时间：<span class="miaoshu"
                  >{{ timeDetail.publicityStartTime }} 至
                  {{ timeDetail.publicityStopTime }}</span
                >
              </div>
              <div
                v-if="
                  (detail.status <= 4 && detail.status >= 2) ||
                  detail.status >= 7
                "
                class="miaoshuBox">
                报名时间：<span class="miaoshu"
                  >{{ timeDetail.applyStartTime }} 至
                  {{ timeDetail.applyStopTime }}</span
                >
              </div>
              <div class="miaoshuBox">
                {{ cityDetail.bidTimeName || '竞价时间' }}：<span
                  class="miaoshu"
                  >{{ timeDetail.biddingStartTime }} 至
                  {{ timeDetail.biddingStopTime }}</span
                >
              </div>
              <div class="miaoshuBox" v-if="cityDetail.showTimeLapse">
                延时周期：
                <el-tooltip placement="top" effect="light">
                  <div slot="content">
                    如果在竞价结束前{{
                      cityDetail.biddingExtension
                        ? cityDetail.biddingExtension
                        : 5
                    }}分钟出价，竞价结束时间会在出价时间
                    <br />
                    基础上延长{{
                      cityDetail.biddingExtension
                        ? cityDetail.biddingExtension
                        : 5
                    }}分钟，直至无人出价，竞价结束<span
                      style="color: #ed222f; cursor: pointer"
                      @click="toTimeLapseDetail"
                      >查看</span
                    >
                  </div>
                  <span class="miaoshu"
                    >{{
                      cityDetail.biddingExtension
                        ? cityDetail.biddingExtension
                        : 5
                    }}分钟 <i class="el-icon-question"></i
                  ></span>
                </el-tooltip>
              </div>

              <div class="gobutton" v-if="detail.status == 2">
                {{ setPorjectShowStatus(detail.status, isApply) }}
              </div>
              <div class="gobutton1" v-if="detail.status == 3">
                {{ setPorjectShowStatus(detail.status, isApply) }}
              </div>
              <div
                class="gobutton"
                @click="toChanquanbaoming"
                v-if="detail.status == 4 && isApply == 0">
                {{ setPorjectShowStatus(detail.status, isApply) }}
              </div>
              <div class="gobutton" v-if="detail.status == 4 && isApply == 1">
                {{ setPorjectShowStatus(detail.status, isApply) }}
              </div>
              <div class="gobutton" v-if="detail.status == 4 && isApply == 2">
                {{ setPorjectShowStatus(detail.status, isApply) }}
              </div>
              <div class="gobutton1" v-if="detail.status == 5">
                {{ setPorjectShowStatus(detail.status, isApply) }}
              </div>
              <div
                class="gobutton1"
                v-if="detail.status == 6 && isApply == 1"
                @click="cityDetail.affirmMoney ? showAffirmMoney : bid">
                {{ setPorjectShowStatus(detail.status, isApply) }}
              </div>
              <div class="gobutton1" v-if="detail.status == 6 && isApply != 1">
                {{ setPorjectShowStatus(detail.status, isApply) }}
              </div>

              <div class="gobutton1" v-if="detail.status >= 7">
                {{ setPorjectShowStatus(detail.status, isApply) }}
              </div>
            </div>
            <div
              style="
                flex: 1;
                padding: 0 16px;
                border-left: 1px solid #d9d9d9;
                margin: 16px 0;
                height: auto;
              "
              v-if="
                (cityDetail.showAuctionRecords ||
                  (detail.status == 6 && isApply == 1)) &&
                !cityDetail.notShowAuctionRecords
              ">
              <div v-if="detail.status < 4">
                距离报名开始：<span style="font-size: 28px; font-weight: 600"
                  >{{ nowDay }}天{{ nowHour }}时{{ nowMinute }}分{{
                    nowSecond
                  }}秒</span
                >
              </div>
              <div v-if="detail.status == 4">
                距离报名截止仅剩<span style="font-size: 28px; font-weight: 600"
                  >{{ nowDay }}天{{ nowHour }}时{{ nowMinute }}分{{
                    nowSecond
                  }}秒</span
                >
              </div>
              <div
                v-if="
                  cityDetail.applyShowBidTime
                    ? detail.status == 6 && isApply == 1
                    : detail.status == 6
                ">
                距离竞价截止仅剩<span style="font-size: 28px; font-weight: 600"
                  >{{ nowDay }}天{{ nowHour }}时{{ nowMinute }}分{{
                    nowSecond
                  }}秒</span
                >
              </div>
              <div
                class="msg"
                v-if="detail.status >= 5 && cityDetail.showBiddingMessage">
                <div class="msgTitle">系统消息</div>
                <div class="msgContent">
                  <span v-if="detail.status >= 7"
                    >感谢各位竞买人积极参与，本次竞价会已圆满结束，欢迎各位竞买人后续积极关注本网站获取更多信息。
                    {{ timeDetail.biddingStopTime }}</span
                  >
                  <span v-if="detail.status >= 6"
                    >竞价会已开始，请各位有意向的竞买人尽快出价！
                    {{ timeDetail.biddingStartTime }}</span
                  >
                  <span v-if="detail.status >= 5"
                    >竞价会即将开始，为避免错过竞价会，请各位竞买人提前15分钟登录账号，竞价过程中出现任何问题及时拨打项目负责人电话咨询。
                    {{ timeDetail.applyStopTime }}</span
                  >
                </div>
              </div>
              <div style="display: flex; flex-direction: column; height: 400px">
                <div
                  style="
                    background-color: #f56c6c;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 10px 10px 0 0;
                  ">
                  <span
                    style="
                      color: #fff;
                      font-size: 30px;
                      font-family: Source Han Sans CN-Regular,
                        Source Han Sans CN;
                      padding: 8px 0;
                      font-weight: 400;
                      height: 54px;
                    "
                    ><span
                      v-if="
                        (detail.status == 6 && isApply == 1) ||
                        cityDetail.showAuctionRecords
                      "
                      >出价记录</span
                    ></span
                  >
                </div>
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    max-height: 85%;
                    overflow: auto;
                    padding: 0 20px;
                  "
                  v-if="
                    (detail.status == 6 && isApply == 1) ||
                    cityDetail.showAuctionRecords
                  ">
                  <div
                    v-for="(data, index) in auctionRecords"
                    :key="index"
                    class="list"
                    :class="{
                      nowUserBid:
                        userInfo &&
                        cityDetail.nowUserBidChangeColor &&
                        data.username == userInfo.userName,
                    }">
                    <span style="flex: 1">{{
                      cityDetail.notShowAuctionRecordsName
                        ? 'xxx'
                        : cityDetail.showPhoneId
                        ? (data.phone + data.id).slice(-4)
                        : data.realname
                    }}</span>
                    <span style="flex: 2">{{ data.createTime }}</span>
                    <span
                      style="flex: 1; text-align: right; white-space: nowrap"
                      >{{ data.money }} 元/年/{{
                        getDictValue(detail.areaUnit, 'area_unit')
                      }}</span
                    >
                  </div>
                </div>
              </div>
              <div style="font-size: 20px; color: red">
                <i class="el-icon-warning"></i
                >重要提示:报价过程数据仅体现标的价格，不包含服务费!
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FLOW />
    <!-- 底部商品详细及交易须知 -->
    <HJXOutProjectDetail
      v-if="cityDetail.cityName == '获嘉县'"
      :detail="detail"
      :backCardInfo="backCardInfo"
      :isLogin="isLogin" />
    <HXSOutProjectDetail
      v-else-if="cityDetail.cityName == '辉县市'"
      :detail="detail"
      :backCardInfo="backCardInfo"
      :isLogin="isLogin" />
    <outProjectDetail
      v-else
      :detail="detail"
      :backCardInfo="backCardInfo"
      :isLogin="isLogin" />
    <el-dialog
      title="出价确认提示"
      :visible.sync="showAffirmMoneyDialog"
      width="700px">
      <span style="font-size: 30px">
        您当前出价为：{{ money }}元，请确认是否出价。
      </span>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button
          type="primary"
          @click="bid"
          style="font-size: 20px; padding: 6px 10px">
          确 认</el-button
        ><el-button
          type="info"
          @click="showAffirmMoneyDialog = false"
          style="font-size: 20px; padding: 6px 10px">
          关 闭</el-button
        >
      </div>
    </el-dialog>
    <el-dialog title="竞价结束提示" :visible.sync="dialogVisible" width="700px">
      <span style="font-size: 30px" v-if="auctionRecords.length > 0">
        恭喜{{
          auctionRecords.length > 0 && auctionRecords[0].realname
        }}中标，中标价格：{{
          auctionRecords.length > 0 && auctionRecords[0].money
        }}元，请及时与产权交易中心工作人员联系办理相关事宜。 </span
      ><span style="font-size: 30px" v-else> 无人出价，竞价结束。 </span>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button
          @click="dialogVisible = false"
          style="font-size: 20px; padding: 6px 10px"
          type="info">
          关 闭</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getProjectDetail,
  getCurrentPrice,
  isApply,
  auctionBid,
  getInfoByDeptId,
  getBankCardInfo,
  watchProject,
  getTypeList,
} from '@/api/交易项目详情'
import FLOW from '../components/Home/First/交易流程.vue'
import { checkToken, getUserInfoByUserId } from '../api/login.js'
import { cityDetail } from '../util/mainOption.js'
import { getNewsDetail, getNewslist } from '../api/mian'
import outProjectDetail from '../components/转出项目商品详细_默认版本.vue'
import HJXOutProjectDetail from '../components/转出项目商品详细_获嘉版本.vue'
import HXSOutProjectDetail from '../components/转出项目商品详细_辉县版本.vue'
export default {
  data() {
    return {
      // 银行信息
      backCardInfo: {},
      // 溢价率
      overRatio: null,
      currentPrice: null, //当前价格
      initPrice: null, //最低价格
      money: null, //出价金额
      minMonery: null, //最小价格

      detail: {}, //项目详情
      timeDetail: {}, //时间详情

      id: '', //项目ID
      imgList: [], //图片列表
      nowDay: '00',
      nowHour: '00',
      nowMinute: '00',
      nowSecond: '00',
      getDetailActive: 1, //项目模块展示
      state: '', //1、已审核2、公示中3、公示结束4、报名中5、报名结束6、竞价中7、交易已完成8、已签订合同9、已打印鉴证书10、无人报名 11、无人竞拍12 可以竞拍
      // 出价记录列表
      auctionRecords: [],
      timer: null,
      isLogin: false, //是否登录
      isApply: 0, //0未报名,1已报名2已报名未审核
      deptName: '',
      dialogVisible: false,
      dictList: {
        // 转出方类别
        out_person_type: [],
        // 招标方式
        invitation_type: [],
        // 单位
        area_unit: [],
        // 农地权属
        land_type: [],
        // 承包方式
        job_type: [],
        // 项目类型
        project_area_type: [],
        // 土地性质
        tdxz_type: [],
        // 转出方式
        out_type: [],
        // 支付方式
        pay_type: [],
        // 出价幅度
        floating_price: [],
        // 是否再次转出
        yes_no: [],
      },
      userInfo: {},
      showPhone: false,
      showRegisternum: false,
      // 是否出价弹窗
      showAffirmMoneyDialog: false,
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  created() {
    for (let dictTitle of Object.keys(this.dictList)) {
      getTypeList(dictTitle).then((res) => {
        this.dictList[dictTitle] = res.data.data
      })
    }
    // console.log(localStorage.getItem('deptName'));
    this.deptName = localStorage.getItem('deptName')
    this.id = this.$route.query.id
    let token = localStorage.getItem('token')
    if (token) {
      checkToken()
        .then((res) => {
          console.log(res)
          if (res.data.code == 200) {
            this.isLogin = true
            getUserInfoByUserId().then((res) => {
              this.userInfo = res.data.data
            })
          } else {
            this.isLogin = false
          }
        })
        .then(() => {
          this.getProject()
        })
        .catch(() => {
          this.getProject()
        })
    } else {
      this.isLogin = false
      this.getProject()
    }
  },
  computed: {
    delayTimeSocket() {
      return this.$store.state.delayTime
    },
    auctionBidSocket() {
      return this.$store.state.auctionBid
    },
  },
  mounted() {
    let data = {
      id: this.id,
    }
    getProjectDetail(data).then((res) => {
      this.detail = res.data.data
      this.getRolloutLimit()
      watchProject({ dataId: Number(this.detail.id), type: 2 }).then((res) => {
        console.log(res)
      })
    })
  },
  watch: {
    delayTimeSocket(nval, oval) {
      if (
        nval == true &&
        this.$store.state.delayTimeData.dataId == this.id &&
        this.$store.state.delayTimeData.dataType == '2'
      ) {
        console.log('delayTimeSocket触发', this.$store.state.delayTimeData)
        clearInterval(this.timer)
        let data = {
          id: this.id,
        }
        getProjectDetail(data).then((res) => {
          this.detail = res.data.data
          this.timeDetail = this.detail.releaseRecord || {} //获取接口报名时间那一块数据
          // 设置倒计时时间
          if (this.detail.status <= 7) {
            this.timer = setInterval(() => {
              if (this.detail.status < 4) {
                this.getCountDown(this.timeDetail.applyStartTime)
              } else if (this.detail.status == 4) {
                this.getCountDown(this.timeDetail.applyStopTime)
              } else if (this.detail.status == 5) {
                this.getCountDown(this.timeDetail.biddingStartTime)
              } else if (this.detail.status == 6) {
                this.getCountDown(this.timeDetail.biddingStopTime)
              } else if (this.detail.status == 7) {
                this.getCountDown(this.timeDetail.biddingStopTime)
              }
            }, 1000)
          } else {
            clearInterval(this.timer)
          }
        })
      }
      this.$store.state.delayTime = false
    },
    auctionBidSocket(nval, oval) {
      if (
        nval == true &&
        this.$store.state.auctionBidData.dataId == this.id &&
        this.$store.state.auctionBidData.dataType == '2'
      ) {
        console.log('auctionBidSocket触发', this.$store.state.auctionBid)
        this.getPrice()
      }
      this.$store.state.auctionBid = false
    },
  },
  methods: {
    toTimeLapseDetail() {
      this.$router.push('/timeLapseDetail')
    },
    numberToChinese(num) {
      num = Number(num)
      const chineseList = [
        '零',
        '一',
        '二',
        '三',
        '四',
        '五',
        '六',
        '七',
        '八',
        '九',
        '十',
      ]
      return chineseList[num]
    },
    // 确认出价弹窗
    showAffirmMoney() {
      if (this.money) {
        this.showAffirmMoneyDialog = true
      } else {
        this.$message.warning('请输入出价金额')
      }
    },
    // 输入框验证价格
    moneyBlur() {
      getCurrentPrice({ projectId: this.id, projectType: 2 }).then((res) => {
        let data = res.data.data
        this.minMonery = data.currentPrice ? data.currentPrice : data.initPrice
        if (
          data.currentPrice
            ? Number(this.money) <= Number(this.minMonery)
            : Number(this.money) < Number(this.minMonery)
        ) {
          this.$message.warning('出价金额需大于当前价格')
        }
      })
    },
    checkShowRegisternum() {
      this.showRegisternum = !this.showRegisternum
    },
    // 获取字典值
    getDictValue(value, dictTitle) {
      if (value !== 0 && value !== '0' && !value) return '暂无'
      return this.dictList[dictTitle].find((item) => item.dictValue == value)
        ? this.dictList[dictTitle].find((item) => item.dictValue == value)
            .dictLabel
        : '暂无'
    },
    // 产权报名
    toChanquanbaoming() {
      if (this.isLogin) {
        this.$router.push({
          name: '产权报名',
          query: { id: this.id, type: 2 },
        })
      } else {
        this.$message.warning('请先登录')
        if (cityDetail.homeShowLogin) {
          this.$router.push('/')
        } else {
          this.$router.push('/login')
        }
      }
    },
    // 轮播切换
    qiehuanlunbo(index) {
      this.$refs.carousel.setActiveItem(index)
      // console.log(index);
    },
    // 获取项目详情
    getProject() {
      let data = {
        id: this.id,
      }
      getProjectDetail(data).then((res) => {
        this.detail = res.data.data
        // console.log(this.detail)
        getInfoByDeptId(this.detail.areanum).then((res) => {
          this.backCardInfo = res.data.data
        })
        this.imgList = this.detail.imgList
        // console.log('res', res.data.data.releaseRecord)
        this.timeDetail = this.detail.releaseRecord || {} //获取接口报名时间那一块数据
        // 已经报名获取出价
        this.getPrice()

        // 设置倒计时时间
        if (this.detail.status <= 7) {
          this.timer = setInterval(() => {
            if (this.detail.status < 4) {
              this.getCountDown(this.timeDetail.applyStartTime)
            } else if (this.detail.status == 4) {
              this.getCountDown(this.timeDetail.applyStopTime)
            } else if (this.detail.status == 5) {
              this.getCountDown(this.timeDetail.biddingStartTime)
            } else if (this.detail.status == 6) {
              this.getCountDown(this.timeDetail.biddingStopTime)
            } else if (this.detail.status == 7) {
              this.getCountDown(this.timeDetail.biddingStopTime)
            }
          }, 1000)
        } else {
          clearInterval(this.timer)
        }

        // 判断是否登录
        if (
          this.isLogin &&
          (this.detail.status == 6 || this.detail.status == 4)
        ) {
          // 判断是否已经报名

          isApply({ projectId: this.detail.id, projectType: 2 }).then(
            (result) => {
              this.isApply = result.data.data
            }
          )
        }
      })
    },

    getRolloutLimit() {
      if (this.detail.outstarttime && this.detail.outstoptime) {
        let starttime = this.detail.outstarttime.split('-')
        let stoptime = this.detail.outstoptime.split('-')
        this.detail.rolloutLimit =
          (Number(stoptime[0]) - Number(starttime[0])) * 12 +
          Number(stoptime[1]) -
          Number(starttime[1]) +
          Number(((Number(stoptime[2]) - Number(starttime[2])) / 30).toFixed(2))
        this.$forceUpdate()
      }
    },
    // 获取当前价格
    getPrice() {
      // 已经报名获取当前溢价和竞价信息
      getCurrentPrice({ projectId: this.id, projectType: 2 }).then((res) => {
        let data = res.data.data
        this.currentPrice = data.currentPrice
          ? data.currentPrice
          : data.initPrice
        this.minMonery = data.currentPrice
          ? Number(this.currentPrice)
          : data.initPrice
        this.initPrice = data.initPrice
        this.overRatio = data.overRatio
        this.auctionRecords = data.auctionRecords
      })
    },
    // 出价
    bid() {
      this.getPrice()
      // 已经报名获取出价
      getCurrentPrice({ projectId: this.id, projectType: 2 }).then((res) => {
        let data = res.data.data
        this.minMonery = data.currentPrice ? data.currentPrice : data.initPrice
        if (
          this.auctionRecords.length > 0 &&
          this.userInfo.phone == this.auctionRecords[0].phone
        ) {
          this.$message.warning('您是当前最高出价人,请等待其他出价人')
        } else {
          if (
            data.currentPrice
              ? Number(this.money) > Number(this.minMonery)
              : Number(this.money) >= Number(this.minMonery)
          ) {
            let obj = {
              money: this.money,
              projectId: this.id,
              projectType: 2,
            }
            auctionBid(obj).then((res) => {
              this.$message.success('出价成功')
            })
          } else {
            this.$message.error('出价金额需大于当前价格')
          }
        }
        this.showAffirmMoneyDialog = false
      })
    },
    // 获取倒计时
    getCountDown(time) {
      // 获取当前时间
      let nowTime = new Date().getTime()
      // 获取截止时间
      let stopTime = new Date(time).getTime()
      // 时间差
      let leadTime = stopTime - nowTime
      let nowDay = Math.floor(leadTime / (1000 * 60 * 60 * 24))
      let lever1 = leadTime % (1000 * 60 * 60 * 24)
      let nowHour = Math.floor(lever1 / (1000 * 60 * 60))
      let lever2 = lever1 % (1000 * 60 * 60)
      let nowMinute = Math.floor(lever2 / (1000 * 60))
      let lever3 = lever2 % (1000 * 60)
      let nowSecond = Math.floor(lever3 / 1000)
      if (leadTime <= 0) {
        if (this.detail.status == 7 && leadTime <= 0 && leadTime > -2000) {
          this.dialogVisible = true
        }
        this.nowDay = 0
        this.nowHour = 0
        this.nowMinute = 0
        this.nowSecond = 0
        clearInterval(this.timer)
        if (this.detail.status != 7) {
          this.getProject()
        }
        // location.reload()
      } else {
        this.nowDay = nowDay
        this.nowHour = nowHour
        this.nowMinute = nowMinute
        this.nowSecond = nowSecond
      }
    },

    channelInputLimit(e) {
      e.returnValue = ''
    },
  },
  components: {
    FLOW,
    outProjectDetail,
    HJXOutProjectDetail,
    HXSOutProjectDetail,
  },
}
</script>

<style>
.el-dialog {
  border-radius: 5px !important;
  margin-top: 40vh !important;
}

.el-dialog__header {
  background: #1890ff;
  border-radius: 5px 5px 0 0;
  text-align: center;
}

.el-dialog__title {
  color: #fff !important;
  margin: 0 auto;
  display: inline-block;
  font-size: 24px;
}

.el-dialog__headerbtn .el-dialog__close {
  color: #fff !important;
}
/* 整个滚动条的样式 */
::-webkit-scrollbar {
  width: 10px; /* 滚动条宽度 */
}

/* 滚动轨道的样式 */
::-webkit-scrollbar-track {
  background: #fff; /* 轨道背景颜色 */
}

/* 滚动滑块的样式 */
::-webkit-scrollbar-thumb {
  background: #ddd; /* 滑块背景颜色 */
  border-radius: 200px;
}

/* 当鼠标悬停在滑块上时改变颜色 */
::-webkit-scrollbar-thumb:hover {
  background: #999; /* 鼠标悬停时的滑块颜色 */
}
</style>

<style scoped lang="scss">
@import url('../util/quill.core.css');
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
.nowUserBid {
  color: #ffb52b !important;
}
.msg {
  display: flex;
  flex-flow: column nowrap;
  border-radius: 8px;
  .msgTitle {
    color: #fff;
    background-color: #f56c6c;
    width: 120px;
    text-align: center;
    height: 40px;
    line-height: 40px;
    border-radius: 8px 8px 0 0;
    font-size: 20px;
  }
  .msgContent {
    display: flex;
    flex-flow: column nowrap;
    border: 1px solid #ec9191;
    margin-bottom: 8px;
    max-height: 140px;
    overflow-y: auto;
    padding: 4px 10px;
    span {
      font-size: 20px;
      text-indent: 2em;
      line-height: 32px;
      color: #ffb52b;
      margin-bottom: 10px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
.imgcontent {
  display: flex;
  /* justify-content: s; */
  flex-wrap: wrap;
}

.lunbo-bottom {
  display: flex;
  /* border: 1px solid red; */
  margin-top: 7px;
  height: 110px;
}

.lunbo-item {
  width: 25%;
  margin-right: 5px;
  cursor: pointer;
}

.lunbo-item:last-child {
  margin-right: 0;
}

.top-title {
  height: 85px;
  border-bottom: #d1d1d2 1px solid;
  padding-left: 30px;
}

.left-bottom {
  font-size: 20px;
  padding: 30px;
  color: #666;
}

.left-bottom > div {
  line-height: 45px;
  height: 45px;
}

.gobutton {
  width: 200px;
  text-align: center;
  margin: 0 auto;
  background-color: #67c23a;
  border-radius: 10px;
  font-size: 25px;
  color: #fff;
  cursor: pointer;
  user-select: none;
}

.gobutton1 {
  width: 200px;
  text-align: center;
  margin: 0 auto;
  background-color: #f56c6c;
  border-radius: 10px;
  font-size: 25px;
  color: #fff;
  cursor: pointer;
  user-select: none;
  margin-top: 20px;
}

.miaoshu {
  color: #333;
}

.sub-title {
  color: #999;
  font-size: 18px;
  margin-top: 15px;
}

.sub-title span {
  margin-right: 50px;
}

.left-xiangqing {
  border: 1px solid #d1d1d2;
  flex: 1;
  margin-left: 30px;
  font-size: 26px;
  padding: 15px 0;
  color: #333;
}

* {
  padding: 0;
  margin: 0;
}

a {
  text-decoration: none;
  color: black;
}

.container {
  margin: 0 auto;
  width: 1860px;
  background-color: #fff;
  padding: 20px;
}

.bread {
  margin: 20px 0;
}

.bread1 {
  font-size: 18px;
}

.particulars {
  width: 30%;
  height: 100%;
}

.slideshow {
  width: 100%;
  /* height: 400px; */
  /* margin-top: 3%; */
  /* margin: /auto 0; */
}

.footer {
  display: flex;
  font-size: 22px;
}

.footerDiv {
  margin: 8px 0;
  font-weight: 600;
}

.footerTitle {
  font-size: 36px;
  height: 15px;
  /* border: #67C23A 1px solid; */
  /* margin-bottom: 40px; */
  color: #f56c6c;
  /* list-style: armenian; */
}

.fengexian {
  margin-bottom: 40px;
}

.fengexian >>> .el-divider__text {
  font-size: 36px;
  /* margin-bottom: 40px; */
  color: #f56c6c;
  list-style: armenian;
}

.fengexian1 {
  margin: 30px 0 50px 0;
}

.fengexian1 >>> .el-divider__text {
  font-size: 36px;
  /* margin-bottom: 40px; */
  color: #f56c6c;
  list-style: armenian;
}
.applyDetail {
  width: 85%;
  height: 55%;
  border: 1px solid #d1d1d2;
}

.getdetail {
  font-size: 24px;
  padding: 0 30px;
  font-weight: 600;
  opacity: 0.5;
}

.getDetail {
  font-size: 24px;
  padding: 0 30px;
  border-top: 1px solid #f56c6c;
  background-color: white;
}

.gettimeDetail {
  color: #f56c6c;
  font-weight: 600;
}

.tableBox {
  display: flex;
}
.left {
  width: 100%;
  text-align: left;
  display: flex;
  max-width: 100%;
  flex-wrap: wrap;
}
.tet {
  border: 1px solid rgb(210, 210, 210);
  /* padding: 30px; */
  margin: 0 !important;
  display: flex;
  width: 50%;
}

.tet1 {
  min-width: 250px;
  max-width: 250px;
  border-right: 1px solid #f3f5f8;
  padding: 20px 20px;
  text-align: center;
  font-weight: 600;
  background-color: #f3f5f8;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tet2 {
  padding: 20px 20px;
  width: 685px;
  max-width: 685px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
}

.tet3 {
  padding: 20px 20px;
  width: 550px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.list {
  font-size: 20px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #606266;
  padding: 10px 0;
  border-bottom: 1px solid #606266;
  display: flex;
  justify-content: space-between;
}

.list:last-child {
  border-bottom: 0;
}

table {
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
  padding: 0;
  margin: 0;
  height: 100%;
}

table td {
  height: auto;
  text-align: left;
  table-layout: fixed;
  padding: 10px 6px;
  font-size: 20px;
  line-height: 100%;
  color: #000000;
  line-height: 40px;
}

table th {
  width: 15%;
  height: auto;
  text-align: left;
  table-layout: fixed;
  padding: 10px 6px;
  font-size: 20px;
  line-height: 100%;
  color: #000000;
  background: #fafafa;
  font-weight: normal;
}

.input-number >>> .el-input__inner {
  font-size: 20px;
  text-align: right;
  font-size: 24px !important;
  font-weight: bold !important;
}
.conent > div {
  margin: 10px 0;
}
</style>
